'use client';

/**
 * AttributionTracker — captura UTMs y click IDs en cada visita.
 *
 * Se monta en el RootLayout (src/app/layout.js). Es un client component
 * silencioso (sin UI) que ejecuta captureAttributionFromURL() al mount.
 *
 * Política first-touch wins: si ya hay attribution válida guardada en
 * localStorage, NO la sobrescribe — solo actualiza last_touch para
 * análisis multi-touch.
 *
 * Renderea null porque no tiene UI. El tracking pasa silenciosamente.
 *
 * Ver src/lib/attribution.js para la lógica completa.
 */

import { useEffect } from 'react';
import { captureAttributionFromURL } from '@/lib/attribution';

export default function AttributionTracker() {
  useEffect(() => {
    // Wrap en try/catch defensivo: si localStorage está disabled (modo privado
    // estricto o cookies bloqueadas), no romper la página.
    try {
      captureAttributionFromURL();
    } catch (err) {
      // Silent fail: el tracking es nice-to-have, NUNCA debe romper la app.
      console.debug('[AttributionTracker] capture failed:', err?.message);
    }
  }, []);

  return null;
}
